import intl from 'react-intl-universal';
import { LOCALE_KEY, locales } from './constants';
import { allLangs, defaultLang } from './langConfig';
import { AppLocale, TranslationKey, TransParams } from './types';

export const getCurrentLocale = (): AppLocale => {
  return (localStorage?.getItem(LOCALE_KEY) as AppLocale) ?? defaultLang.value;
};

export const setCurrentLocale = (locale: string): void => {
  localStorage?.setItem(LOCALE_KEY, locale);
};

export const initIntl = async (locale?: string | undefined) => {
  await intl.init({
    locales,
    currentLocale: locale ?? getCurrentLocale()
  });
};

export const getTrans = (key: TranslationKey) => {
  return intl.get(key);
};

export const getTransWithParams = (
  key: TranslationKey,
  params: TransParams
) => {
  return intl.get(key, params);
};

export const getLocaleLanguage = (): AppLocale =>
  (intl.getInitOptions().currentLocale as AppLocale) || defaultLang.value;

export const getLocale = () => {
  const localeStr = getLocaleLanguage();
  if (localeStr?.includes(AppLocale.en_US)) {
    return allLangs[AppLocale.en_US].adapterLocale;
  }
  return allLangs[AppLocale.de_DE].adapterLocale;
};
